"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverArrow = exports.PopoverArrowBorder = exports.PopoverChildrenContainer = exports.PopoverCloseButton = exports.HeaderText = exports.PopoverHeaderContainer = exports.PopoverInner = exports.PopoverContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const themed_text_1 = require("../themed-text");
const setBubbleNotchPosition = (props) => {
    const notchHorizontalPosition = props.bubbleNotchHorizontalPosition;
    const leftPosition = `left: ${notchHorizontalPosition}px`;
    return (0, styled_components_1.css) `
    ${leftPosition};
    bottom: -13px;
  `;
};
exports.PopoverContainer = styled_components_1.default.div `
  overflow: hidden;
  border: 1px solid ${monera_app_core_1.Gray_1000};
  border-color: ${monera_app_core_1.Gray_1000};
  height: 100%;
  width: 100%;
  border-radius: 8px;
  margin-top: -8px;
  box-shadow: 0 2px 5px rgba(15, 17, 17, 0.15);
  color: ${monera_app_core_1.Gray_100};
`;
exports.PopoverInner = styled_components_1.default.div `
  background-color: #fff;
  padding: 14px 16px;
  text-align: left;
  overflow-x: hidden;
`;
exports.PopoverHeaderContainer = styled_components_1.default.div `
  display: flex;
  width: 100%;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.spacings.medium};
`;
exports.HeaderText = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  padding-right: 60px;
`;
exports.PopoverCloseButton = styled_components_1.default.button `
  position: fixed;
  width: 52px;
  height: 52px;
  border: 0;
  padding: 0;
  border-radius: 50%;
  top: 0;
  right: 1px;
  background-color: transparent;
  cursor: pointer;
`;
exports.PopoverChildrenContainer = styled_components_1.default.div `
  width: calc(100% - 15px);
`;
exports.PopoverArrowBorder = styled_components_1.default.div `
  position: absolute;
  width: 8px;
  height: 8px;
  border-top: 0;
  border: 1px solid transparent;
  border-top-color: ${monera_app_core_1.Gray_1000};
  border-left-color: ${monera_app_core_1.Gray_1000};
  background: white;
  transform: rotate(45deg);
  ${setBubbleNotchPosition}
`;
exports.PopoverArrow = styled_components_1.default.div `
  top: 1px;
  right: -8px;
  border-top: 0;
`;
